/**
 * Traduz dias da semana em descrições de escala/turno de passageiros
 * conforme o locale da UI (dados cadastrais podem estar em PT ou ES).
 */
const REPLACEMENTS = {
  'pt-BR': [
    [/Mi[eé]rcoles/gi, 'Quarta'],
    [/Lunes/gi, 'Segunda'],
    [/Martes/gi, 'Terça'],
    [/Jueves/gi, 'Quinta'],
    [/Viernes/gi, 'Sexta'],
    [/S[aá]bados/gi, 'Sábados'],
    [/S[aá]bado/gi, 'Sábado'],
    [/Domingo/gi, 'Domingo'],
  ],
  'es-MX': [
    [/Segunda[-\s]?feiras?/gi, 'Lunes'],
    [/Ter[cç]a[-\s]?feiras?/gi, 'Martes'],
    [/Quarta[-\s]?feiras?/gi, 'Miércoles'],
    [/Quinta[-\s]?feiras?/gi, 'Jueves'],
    [/Sexta[-\s]?feiras?/gi, 'Viernes'],
    [/Segundas?/gi, 'Lunes'],
    [/Ter[cç]as?/gi, 'Martes'],
    [/Quartas?/gi, 'Miércoles'],
    [/Quintas?/gi, 'Jueves'],
    [/Sextas?/gi, 'Viernes'],
    [/S[aá]bados/gi, 'Sábados'],
    [/S[aá]bado/gi, 'Sábado'],
    [/Domingos?/gi, 'Domingo'],
  ],
};

export default function translatePassengerShiftDescription(text, locale) {
  if (text == null || text === '') return text;
  const rules = REPLACEMENTS[locale] || REPLACEMENTS['pt-BR'];
  if (!rules) return text;
  let out = String(text);
  for (let i = 0; i < rules.length; i++) {
    out = out.replace(rules[i][0], rules[i][1]);
  }
  return out;
}
